import { render, staticRenderFns } from "./modeswitch.vue?vue&type=template&id=327f9b38"
import script from "./modeswitch.vue?vue&type=script&lang=js"
export * from "./modeswitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports